/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteHazard$Params {

/**
 * The customer id
 */
  customerId: number;

/**
 * The hazard factor id
 */
  hazardId: number;
}

export function deleteHazard(http: HttpClient, rootUrl: string, params: DeleteHazard$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteHazard.PATH, 'delete');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.path('hazardId', params.hazardId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteHazard.PATH = '/customers/{customerId}/hazards/{hazardId}';
